import React, { useEffect, useState } from 'react';
import HeaderLogged from './components/header_logged';
import api from './api/client';
import AdminTabs from './components/AdminTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import './admin-panel.css';

// Страница /admin/requests (раздел admin-users): заявки на доступ с /sign-up.
// Одобрение: выбрать роль и задать пароль — создаётся сотрудник с аккаунтом.
function AccessRequestsPage() {
    const [pending, setPending] = useState([]);
    const [decided, setDecided] = useState([]);
    const [roles, setRoles] = useState([]);
    const [error, setError] = useState(null);
    const [approving, setApproving] = useState(null); // id заявки с открытой формой
    const [approveForm, setApproveForm] = useState({ role_id: '', password: '' });

    const load = () => {
        api.get('/api/admin/access-requests')
            .then(r => { setPending(r.data.pending); setDecided(r.data.decided); })
            .catch(err => setError(err.response?.data?.error || 'Failed to load requests'));
    };

    useEffect(() => {
        load();
        api.get('/api/admin/roles')
            .then(r => setRoles(r.data))
            .catch(err => setError(err.response?.data?.error || 'Failed to load roles'));
    }, []);

    const approve = (id, e) => {
        e.preventDefault();
        setError(null);
        api.post(`/api/admin/access-requests/${id}/approve`, {
            role_id: Number(approveForm.role_id),
            password: approveForm.password,
        })
            .then(() => {
                setApproving(null);
                setApproveForm({ role_id: '', password: '' });
                load();
            })
            .catch(err => setError(err.response?.data?.error || 'Failed to approve'));
    };

    const reject = (id) => {
        if (!window.confirm('Reject this request?')) return;
        setError(null);
        api.post(`/api/admin/access-requests/${id}/reject`)
            .then(load)
            .catch(err => setError(err.response?.data?.error || 'Failed to reject'));
    };

    const fmt = (d) => (d ? new Date(d).toLocaleString() : '—');

    return (
        <>
            <HeaderLogged />
            <div className="roles-page">
                <div className="roles-page__head">
                    <h2>Access Requests</h2>
                    <span className="admin-panel__muted">{pending.length} pending</span>
                </div>

                <AdminTabs />

                {error && (
                    <div className="admin-panel__error">
                        <FontAwesomeIcon icon={faCircleExclamation} /> {error}
                    </div>
                )}

                <div className="roles-page__grid-wrap">
                    <table className="admin-panel__table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Login</th>
                                <th>Email</th>
                                <th>Requested</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pending.map(r => (
                                <React.Fragment key={r.id}>
                                    <tr>
                                        <td>{r.firstName} {r.lastName || ''}</td>
                                        <td>{r.login}</td>
                                        <td>{r.email || <span className="admin-panel__muted">—</span>}</td>
                                        <td className="audit-table__when">{fmt(r.created_at)}</td>
                                        <td className="admin-panel__actions">
                                            <button type="button" title="Approve"
                                                onClick={() => setApproving(approving === r.id ? null : r.id)}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </button>
                                            <button type="button" title="Reject" onClick={() => reject(r.id)}>
                                                <FontAwesomeIcon icon={faXmark} />
                                            </button>
                                        </td>
                                    </tr>
                                    {approving === r.id && (
                                        <tr className="admin-panel__sub-row">
                                            <td colSpan={5}>
                                                <form className="admin-panel__inline-form" onSubmit={(e) => approve(r.id, e)}>
                                                    <select required
                                                        value={approveForm.role_id}
                                                        onChange={e => setApproveForm({ ...approveForm, role_id: e.target.value })}
                                                    >
                                                        <option value="" disabled>Role…</option>
                                                        {roles.map(role => <option key={role.id} value={role.id}>{role.title}</option>)}
                                                    </select>
                                                    <input placeholder="Password" type="password" required minLength={6}
                                                        value={approveForm.password}
                                                        onChange={e => setApproveForm({ ...approveForm, password: e.target.value })} />
                                                    <button type="submit" className="admin-panel__save-btn">
                                                        Approve &amp; Create Account
                                                    </button>
                                                </form>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            {pending.length === 0 && (
                                <tr><td colSpan={5} className="admin-panel__muted">No pending requests</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {decided.length > 0 && (
                    <>
                        <h3 className="access-requests__history-title">Recent decisions</h3>
                        <div className="roles-page__grid-wrap">
                            <table className="admin-panel__table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Login</th>
                                        <th>Status</th>
                                        <th>Decided by</th>
                                        <th>When</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {decided.map(r => (
                                        <tr key={r.id}>
                                            <td>{r.firstName} {r.lastName || ''}</td>
                                            <td>{r.login}</td>
                                            <td>
                                                <span className={`admin-panel__status-badge ${r.status === 'approved' ? 'is-active' : 'is-disabled'}`}>
                                                    {r.status}
                                                </span>
                                            </td>
                                            <td>{r.decided_by_name || '—'}</td>
                                            <td className="audit-table__when">{fmt(r.decided_at)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default AccessRequestsPage;
